var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-wrapper"},[_c('Shimmer',{staticClass:"is-desktop",attrs:{"width":"100%","height":"343px"}}),_vm._v(" "),_c('Shimmer',{staticClass:"is-mobile",attrs:{"width":"100%","height":"230px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }